(function () {
  // ✅ شغال على كل الصفحات: Home + Collections + أي صفحة
  var KEY_PREFIX = 'sr:';

  function keyForCurrent() {
    return KEY_PREFIX + window.location.href;
  }

  function saveNow() {
    try {
      sessionStorage.setItem(keyForCurrent(), String(window.scrollY || 0));
    } catch(e) {}
  }

  function restoreNow() {
    var key = keyForCurrent();
    var saved = null;

    try { saved = sessionStorage.getItem(key); } catch(e) {}

    if (!saved) {
      // مفيش restore مطلوب
      document.documentElement.classList.remove('sr-pending');
      return;
    }

    var y = parseInt(saved, 10);
    if (isNaN(y)) y = 0;

    // ✅ ريستور بسرعة قبل الإظهار
    window.scrollTo(0, y);

    // ✅ تثبيت الريستور مرتين RAF عشان مفيش أي قفزة
    requestAnimationFrame(function () {
      window.scrollTo(0, y);

      requestAnimationFrame(function () {
        window.scrollTo(0, y);

        // ✅ إظهار الصفحة
        document.documentElement.classList.remove('sr-pending');
      });
    });

    // ✅ Safety: لو حصل أي خطأ، متسيبش الصفحة مخفية
    setTimeout(function () {
      document.documentElement.classList.remove('sr-pending');
    }, 1200);
  }

  // ✅ حفظ على طول أثناء الاسكرول (خفيف)
  window.addEventListener('scroll', function () {
    saveNow();
  }, { passive: true });

  // ✅ حفظ قبل الريفريش/إغلاق/تنقل
  window.addEventListener('pagehide', saveNow);
  window.addEventListener('beforeunload', saveNow);

  // ✅ ريستور بعد الرجوع من BFCache أو بعد refresh
  window.addEventListener('pageshow', function () {
    restoreNow();
  });
})();